import {createSelector} from 'reselect';
import {Map} from 'immutable';
import {emptyMapIfUndefined} from 'utils/HelperFunctions';

const notesSelector = state => state.appState.getIn(['serverData', 'actionRequired','notes']);

export const getNotes = createSelector(notesSelector, (notes) => {
    return emptyMapIfUndefined(notes)
});
